// import React, { useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { GOOGLE_CLIENT_ID } from "../../utils/appConstant";
import { toast, Slide } from "react-toastify";
import { loginThroughGoogleAuth, maintenance_info } from "../../api/axiosInstanceApi";
import { authErrorToast } from "../../utils/common";

function GoogleAuthLogin() {
  const navigate = useNavigate();
  let user_data = {
    email: "",
    name: "",
    mentee_id: "",
    login_type:""
  };
  const notifyError = () => {
    toast.error("Login Failed!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Slide,
      style: { backgroundColor: "rgb(30 41 59)" }
    });
  };
  async function maintenance_api() {
    const m_res = await maintenance_info();
    return m_res.data.m;
  }
  return (
      <div className="flex justify-center items-center  h-full">
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} >
          <GoogleLogin
            // ux_mode="redirect"
            size="medium"
            // width={600}
            type='standard'
            theme="filled_blue"
            logo_alignment="center"
            text="signin_with"
            shape="rectangular"
            
        
            onSuccess={async credentialResponse => {
              if (credentialResponse.credential) {
                try {
                  const loginRes = await loginThroughGoogleAuth(credentialResponse.credential);

                  user_data.email = loginRes.data.email;
                  user_data.name = loginRes.data.name;
                  user_data.mentee_id = loginRes.data.mentee_id;
                  user_data.login_type = loginRes.data.login_type;
                  // const maintenance = loginRes.data.m;

                  localStorage.setItem("mentee_data", JSON.stringify(user_data));
                  const maintenance = await maintenance_api();
                  navigate("/", { state: { maintenance } });
                  navigate("/", { state: { maintenance } });
                } catch (e:any) {
                  console.log(e)
                  authErrorToast(e.response.data.message);
                }
              } else {
                console.error("Credential is undefined");
              }
            }}
            useOneTap={true}
            onError={() => {
              notifyError();
              console.log("Login Failed");
            }}
          />
        </GoogleOAuthProvider>
      </div>
  );
}

export default GoogleAuthLogin;
